import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root'
})
export class EstadoService {

  constructor() { }

  addEstado(){
    return gql`
      mutation createEstado($input: createEstadoInput!) {
        createEstado(input: $input) {
          estado {
            id
            color
            gestor{
              id
            }
         }
        }
      }
    `;
  }
}
